import { Routes, Route, Navigate } from 'react-router-dom'

import { PublicRoutes } from './'
import { ErrorBoundary, ErrorScreen } from '../components'
import Layout from '../components/Layout/Layout'
import { useUser } from '../context'
import { ProfilePage, InitialForm } from '../pages'
import ProfessorsPage from '../pages/ProfessorsPage'
import { ProfesorStudentMenu, URLNavigation } from '../types'

export const AppRouterProfessor = () => {
  // TODO: replace with
  // const { loadingUser, userRole, loadError } = useUser()
  // const { professorsLoading, professorsError } = useProfessors()
  // if (loadError) return <ErrorScreen />
  // if (loadError) {
  //   return <ErrorScreen message="No pudimos validar tu sesión." />
  // }

  // if (loadingUser) {
  //   return <Spinner />  // o el componente que prefieras
  // }

  // if (professorsError) {
  //   return <ErrorScreen message={professorsError} />
  // }

  // if (professorsLoading) {
  //   return <Spinner />
  // }
  const { userRole, loadingUser, initDone } = useUser()

  if (loadingUser || initDone) {
    return <div>Loading...</div>
  }

  return (
    // <BrowserRouter>
    <ErrorBoundary fallback={<ErrorScreen />}>
      <Layout>
        <Routes>
          {userRole && initDone ? (
            <>
              <Route index element={<ProfessorsPage part="dashboard" />} />
              <Route path="/" element={<ProfessorsPage part="dashboard" />} />
              <Route path="/perfil" element={<ProfilePage />} />
              <Route path="/cursos" element={<ProfilePage />} />
              <Route
                path={URLNavigation.STUDENTS}
                element={
                  <ProfessorsPage part={ProfesorStudentMenu.logs.label} />
                }
              />
              <Route
                path={URLNavigation.LINKS}
                element={
                  <ProfessorsPage part={ProfesorStudentMenu.links.label} />
                }
              />
              <Route
                path={URLNavigation.STUDENT_PROFILE}
                element={
                  <ProfessorsPage part={ProfesorStudentMenu.profile.label} />
                }
              />
              <Route
                path={URLNavigation.CHAT}
                element={
                  <ProfessorsPage part={ProfesorStudentMenu.chat.label} />
                }
              />
              <Route
                path={URLNavigation.ROUTINE}
                element={
                  <ProfessorsPage part={ProfesorStudentMenu.routine.label} />
                }
              />

              <Route
                path="/nuevo-usuario"
                element={<ProfessorsPage part="admin-new-user" />}
              />

              <Route path="/initial-form" element={<InitialForm />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </>
          ) : (
            <Route path="/*" element={<PublicRoutes />} />
          )}
        </Routes>
      </Layout>
    </ErrorBoundary>
    // </BrowserRouter>
  )
}
